import { OptionsViewModel } from './common.models';
import { AccountType } from './Account';
import { ContractBalancesViewModel } from './Contract';

interface HostedCheckoutTransactionModel {
  accountId?: number;
  contractId?: number;
  initialAmount?: number;
  multiplePayments?: Array<ContractBalancesViewModel>;
  numberOfInstallments?: number;
  remainingBalance?: number;
  swoId?: number;
}

export interface HostedCheckoutTransactionCreateModel extends HostedCheckoutTransactionModel {
  type: HostedCheckoutTransactionType;
}

export interface HostedCheckoutTransactionViewModel extends HostedCheckoutTransactionModel {
  accountTypeCode?: AccountType;
  bankMessage?: string;
  bankResponseCode?: string | PayeezyBankResponseCodes;
  creditCardLastFour?: string;
  status?: OptionsViewModel;
  transactionId?: string;
  type: OptionsViewModel;
}

export enum HostedCheckoutTransactionType {
  Undefined = -1,
  PreAuthorization = 1,
  UpdateInstallmentsAuthorization = 2,

  ContractFullPayment = 11,
  RenewalFullPayment = 12,

  ContractInstallmentsPayment = 21,
  RenewalInstallmentsPayment = 22,
  ServiceFeePayment = 31,

  CombinedPayments = 33
}

export enum HostedTransactionStatus {
  Undefined = -1,
  Pending = 11,
  Approved = 21,
  Denied = 31,
  Cancelled = 40,
  Error = 41
}

export enum PaymentMethods {
  CreditCard = 1,
  CCInstallments = 2,
  ACH = 3,
  ACHInstallments = 4
}

export enum PayeezyBankResponseCodes {
  Approved = '000',
  InvalidExpirationDate = '605',
  AuthorizationDeclined = '200',
  RequestDenied = '218',
  BankNetworkDownRetry = '292',
  BusyRetry = '294',
  ErrorRetry = '297',
  Retry = '299'
}



// WEBPACK FOOTER //
// ./src/_models/HostedCheckoutTransactionViewModel.ts